export default __webpack_public_path__ + "static/media/goals.249e06c8.svg";